import React, { Component } from "react";
import { cloneDeep } from "lodash";
import { Col, Form, Input, InputNumber, Modal, Row, Select } from "antd";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { Upload } from 'antd';
import {PlusOutlined, ProjectOutlined} from '@ant-design/icons';
import {Constants, ProductUnits} from "../scripts/settings";
class ProductForm extends Component {
  constructor() {
    super();

    this.state = {

      tags: [],
      packages: [],
      imageGallery: [],
      imageGalleryData: [],
      isEdit: false, // اضافه کردن این خط


    };

    this.formRef = React.createRef();
  }

  handleChange = () => {
    this.formRef.current.setFieldsValue({ subCategory: undefined });
  };

  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      const formData = new FormData();

      formData.append("name", values.name);
      // formData.append("code", values.code);
        // فقط اگر در حالت ویرایش نیستیم (یعنی محصول جدید است) کد را ارسال کن
    // if (!this.state.isEdit && values.code) {
    //   formData.append("code", values.code);
    // }
      formData.append("safeFloor", values.safeFloor);
      formData.append("inventory", values.inventory);
      formData.append("unit", values.unit);

          // تمیز کردن مقدار قیمت از کاماهای احتمالی و تبدیل به رشته/عدد خالص
    const rawPriceOne = values.priceOne !== undefined && values.priceOne !== null
      ? String(values.priceOne).replace(/,/g, "")
      : "";
      formData.append("priceOne", rawPriceOne);
      // formData.append("priceTwo", values.priceTwo);
      // formData.append("priceThree", values.priceThree);
      for (const element of  this.state.imageGallery) {
        if(element.originFileObj != undefined){
          formData.append("images[]", element.originFileObj)
        }
      }

      if (values.tags.length) {
        values.tags.forEach((o) => {
          formData.append("tags[]", o);
        });
      }
      if (values.packages.length) {
        values.packages.forEach((o) => {
          formData.append("packages[]", o);
        });
      }

      if (values.category) formData.append("category", values.category);

      if (values.subCategory)
        formData.append("subCategory", values.subCategory);

      if (values.description)
        formData.append("description", values.description);

      this.props.onSubmit(formData);
    });
  };

  handleWillUnmount = () => {
    this.formRef.current.resetFields();
  };

  handleDidMount = async (data = {}) => {
    const isEdit = !!(data && data.id); // اگر ID وجود داشت یعنی در حالت ویرایش هستیم
    this.setState({ isEdit });
    const cloneData = cloneDeep(data);

    cloneData.tags = [];
    cloneData.packages = [];

    await this.setState({imageGallery: []})
    let {imageGallery} = this.state


    if (cloneData.gallery && cloneData.gallery.length) {
      await cloneData.gallery.forEach((o) => {
        imageGallery.push({
          uid: o.id,
          name: o.id,
          status: 'done',
          url: `${Constants.imagePathProduct}${o.image}`,

        })
      });
    }
    this.setState({imageGallery: imageGallery})

    if (cloneData.tag && cloneData.tag.length) {
      cloneData.tag.forEach((o) => {
        cloneData.tags.push(o.id);
      });
    }
    if (cloneData.package && cloneData.package.length) {
      cloneData.package.forEach((o) => {
        cloneData.packages.push(o.id);
      });
    }


    cloneData.category = cloneData.category ? cloneData.category.id : undefined;
    cloneData.subCategory = cloneData.sub_category
      ? cloneData.sub_category.id
      : undefined;

    this.formRef.current.setFieldsValue(cloneData);
  };

  handleChangeImage = (data) => {
    // this.setState({ fileList })

    if((data.file.status == "removed") && (data.file.originFileObj == undefined)){
      const params = { "imgId": data.file.uid}
      API.product.deleteImage(data.file.uid)
          .then((result) => {
            if (result) {
              this.setState({
                loading: false,
              });
            } else {
              this.setState({ loading: false } );
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
    }

    this.setState({imageGallery: data.fileList, imageGalleryData: data.file})
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
  };

  getBase64 = (file) =>{
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  render() {
    const { mainCats, onCancel, subCats, submitting, tags, visible, packages } = this.props;
    const {imageGallery} = this.state;

    const options = tags.map((o) => {
      return { label: o.name, value: o.id };
    });

    const packageOptions = packages.map((o) => {
      return { label: o.title, value: o.id, name:o.title };
    });
    const props = {
      listType: "picture-card",
      multiple: true,
      onRemove: (file) => {
        let newFileList = imageGallery.find((item) => item === file);
        this.setState({
          fileList: [...imageGallery.filter((item) => item !== newFileList)],
        });
      },
      beforeUpload: (_, newFileList) => {
        this.setState({ imageGallery: [...imageGallery, ...newFileList] });
        return false;
      },
      imageGallery,
    };

    const uploadButton = (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
      <Modal
        title={Resources.edit}
        visible={visible}
        onOk={this.handleSubmit}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        okButtonProps={{ loading: submitting }}
        cancelButtonProps={{ disabled: submitting }}
        width={748}
      >
        <Form ref={this.formRef} layout="vertical">
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item
                name="name"
                label={`${Resources.firstName} ${Resources.product}`}
                rules={Rules.required}
              >
                <Input type="text" prefix={<UserOutlined />}  />
              </Form.Item>
            </Col>
            {this.state.isEdit && (
              <Col xs={24} md={8}>
                <Form.Item
                  name="code"
                  label={Resources.barcode}
                >
                  <Input
                    type="text"
                    prefix={<BarcodeOutlined />}
                    dir="ltr"
                    readOnly
                  />
                </Form.Item>
              </Col>
            )}


            {/* <Col xs={24} md={8}>
              <Form.Item
                name="code"
                label={Resources.barcode}
              >
                <Input
                  type="text"
                  prefix={<BarcodeOutlined />}
                  dir="ltr"

                />
              </Form.Item>
            </Col> */}
            {/* <Col xs={24} md={8}>
              <Form.Item
                name="safeFloor"
                label={Resources.safeFloor}
                rules={Rules.required}
              >
                <InputNumber
                  min={0}
                  prefix={<FundViewOutlined />}
                  dir="ltr"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} md={8}>
              <Form.Item
                name="inventory"
                label={Resources.inventory}
                rules={Rules.required}
              >
                <Input type="text" prefix={<BankOutlined />} dir="ltr" />
              </Form.Item>
            </Col>
           <Col xs={24} md={8}>
            <Form.Item
              name="priceOne"
              label={Resources.price}
              rules={Rules.required}
            >
              <InputNumber
                prefix={<DollarCircleOutlined />}
                dir="ltr"
                style={{ width: "100%" }}
                // فرمت‌دهی مقدار ورودی به صورت سه رقم سه رقم
                formatter={(value) => {
                  if (!value) return "";
                  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }}
                // حذف کاماها برای ذخیره و پردازش مقدار عددی خالص
                parser={(value) => {
                  if (!value) return "";
                  return value.replace(/\$\s?|(,*)/g, "");
                }}
              />
            </Form.Item>
          </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="category"
                label={`${Resources.category} ${Resources.main}`}
              >
                <Select
                  filterOption
                  onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  {mainCats.map((cat) => (
                    <Select.Option key={cat.id} value={cat.id} name={cat.name}>
                      {cat.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.category !== currentValues.category
                }
                noStyle
              >
                {({ getFieldValue }) => (
                  <Form.Item
                    name="subCategory"
                    label={`${Resources.category} ${Resources.sub}`}
                  >
                    <Select
                      filterOption
                      placeholder={Resources.choose}
                      optionFilterProp="name"
                      style={{ display: "block" }}
                      showSearch
                    >
                      {subCats
                        .filter(
                          (o) =>
                            parseInt(o.subCategory) ===
                            getFieldValue("category")
                        )
                        .map((cat) => (
                          <Select.Option
                            key={cat.id}
                            value={cat.id}
                            name={cat.name}
                          >
                            {cat.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="tags" label={Resources.tags}>
                <Select
                  mode="multiple"
                  options={options}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col md={12} xs={24}>
              <Form.Item name="packages" label={Resources.package}>
                <Select
                    mode="multiple"
                    optionFilterProp="name"
                    options={packageOptions}
                    style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col md={12} xs={24}>
              <Form.Item name="unit" label={Resources.unit}>
                <Select
                    optionFilterProp="name"
                    options={ProductUnits}
                    style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            
            <Col xs={24}>
              <Form.Item name="description" label={Resources.description}>
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <h4 className="id card-name" style={{
                background: "#645a5a",
                color: "white",
                textAlign: "center",
                fontSize: "large"}}>گالری تصاویر</h4>
              <Col xs={24}>
                <Form.Item name="img" label={Resources.image}>
                  <Upload {...props}
                          onPreview={this.handlePreview}
                          onChange={this.handleChangeImage}
                          fileList={imageGallery}
                  >
                    {imageGallery.length >= 8 ? null : uploadButton}
                  </Upload>
                </Form.Item>
              </Col>
            </Col>

          </Row>
        </Form>
      </Modal>
    );
  }
}

export default ProductForm;
